export default {
  data() {
    return {
      groupNum: "202412061059033397414"
    };
  },
  methods: {
    onCopy() {
      try {
        navigator.clipboard
          .writeText(this.groupNum)
          .then(() => {
            this.$MdMessage({
              message: this.$t("mx.copySuccess"),
              type: "success",
            });
          })
          .catch((error) => {
            console.dir(error);
            this.$MdAlert(
              this.$t("mx.copyError"),
              this.$t("mx.copyErrorTitle"),
              {
                showClose: false,
                customClass: "md-messagebox",
              }
            );
          });
      } catch (error) {
        console.dir(error);
        this.$MdAlert(this.$t("mx.copyError"), this.$t("mx.copyErrorTitle"), {
          showClose: false,
          customClass: "md-messagebox",
        });
      }
    }
  }
}
